export const PROJECT_FILE_FORMAT_VERSION = '0.0.3';
export const isCompatible = (project) => (project?.fileFormatVersion === PROJECT_FILE_FORMAT_VERSION);
//# sourceMappingURL=projectFileAPI.js.map